<script>
    import { onMount } from 'svelte';
    import { db, break_session, user, hashtag } from './stores.js';
    let videoURL;
    onMount(async () => {
        $db.collection("breaks").doc($break_session.id).get().then((doc) => {
            if (doc.exists) {
                console.log("Document data: ", doc.data());
                videoURL =  doc.data().highlights[$user.uid]
            } else {
                console.log("No such document!");
            }
        }).catch((error) => {
            console.error("Error getting document: ",error);
        })

    });

</script>

<section>
    <div>
        <video src={videoURL} controls></video>
        <br/><a href={videoURL} target="_blank" download="hightlight-{$break_session.id}">download (right click to save)</a> | <a id="tweet-link" href="https://twitter.com/intent/tweet?hashtags=WorkinOnIt,{$hashtag},HIPHOP,CODE,HIPHOPandCODE&text=Break Session is over! Back to building at https://untilit.works/break/{$break_session.id}/{$user.uid} (a @lifelongdev project)" target="_blank">Send a tweet!</a>    
    
    </div>
</section>

<style>
    section {
        height: 100%;
        width: 100%;
        max-width: 1500px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: auto;
    }

</style>